export default "__VITE_ASSET__Ddzg7Fx4__"